// Chakra Imports
import {
  Box,
  Flex,
  Heading,
  Image,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import AdminNavbarLinks from "common/components/navbar/NavbarLinksAdmin";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { AiOutlineMenuUnfold } from "react-icons/ai";
import { AiOutlineMenuFold } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { fetchImage } from "../../redux/reducers/imageSlice";
import { useNavigate } from "react-router-dom";
import logoWhite from "common/assets/img/logoWhite1.png";
import logoMain from "common/assets/img/logoMain.png";
import Content from "common/components/sidebar/Content";

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const {
    secondary,
    message,
    subRoute,
    isUserLayout,
    brandText,
    under,
    setOpenSidebar,
    openSidebar,
    openSubBar,
    setOpenSubBar,
    largeLogo,
    routes,
  } = props;
  const navigate = useNavigate();
  useEffect(() => {
    window.addEventListener("scroll", changeNavbar);

    return () => {
      window.removeEventListener("scroll", changeNavbar);
    };
  });

  // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
  let mainText = useColorModeValue("navy.700", "white");
  let secondaryText = useColorModeValue("gray.700", "white");
  let navbarPosition = "fixed";
  let navbarFilter = "none";
  let navbarBackdrop = "blur(20px)";
  let navbarShadow = "none";
  let navbarBg = useColorModeValue("#fff", "rgba(11,20,55,0.5)");
  let navbarBorder = "transparent";
  let secondaryMargin = "-9px";
  let paddingX = "15px";
  let gap = "0px";
  let size = "sm";
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  let sidebarBg = useColorModeValue("white", "navy.800");
  let sidebarMargins = "0px";
  let variantChange = "0.2s linear";
  let shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );

  return (
    <Box
      className="removeBorder removeSpacing removeShadow"
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      backgroundPosition="center"
      backgroundSize="cover"
      // borderRadius='16px'
      borderWidth="1.5px"
      borderStyle="solid"
      zIndex={101}
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ xl: "center" }}
      display={secondary ? "block" : "flex"}
      minH="56px"
      justifyContent={{ xl: "center" }}
      // pb='6px'
      right={{ base: "0px" }}
      // right={{ base: '12px', md: '30px', lg: '30px', xl: '30px' }}
      // px={{
      // 	sm: paddingX,
      // 	md: '10px'
      // }}
      // ps={{
      // 	xl: '12px'
      // }}
      top={{ base: "0px" }}
      w={{
        base: "100vw",
        // base: 'calc(100vw - 0%)',
        // md: 'calc(100vw - 0%)',
        // lg: 'calc(100vw - 0%)',
        // xl: openSidebar === true ? 'calc(100vw - 286px)' : 'calc(100vw - 80px)',
        // '2xl': openSidebar === true ? 'calc(100vw - 286px)' : 'calc(100vw - 80px)'
      }}
    >
      <Flex
        w="100%"
        className="topNav"
        flexDirection={{
          sm: "column",
          md: "row",
        }}
        alignItems={{ xl: "center" }}
        mb={gap}
      >
        <Box
          className="topNav-leftContent"
          //  mb={{ sm: '8px', md: '10px' }}
          //  pt="15px"
          display={"flex"}
          alignItems={"center"}
        >
          {/*
					<Breadcrumb>
						<BreadcrumbItem color={secondaryText} fontSize='sm' mb='5px'>
							<BreadcrumbLink as={rrd.Link} to='/admin/default' color={secondaryText}>
								<AiTwotoneHome />
							</BreadcrumbLink>
						</BreadcrumbItem>

						{under?.under && <BreadcrumbItem color={secondaryText} fontSize='sm' mb='5px'>
							<BreadcrumbLink as={rrd.Link} to={`${under.both === true ? '' : under.layout + '/'}${under.under}`} color={secondaryText}>
								{under.parentName}
							</BreadcrumbLink>
						</BreadcrumbItem>}


						<BreadcrumbItem color={secondaryText} fontSize='sm' mb='5px'>
							<BreadcrumbLink as={rrd.Link} to='#' color={secondaryText}>
								{brandText}
							</BreadcrumbLink>
						</BreadcrumbItem>

					</Breadcrumb>
					*/}
          <Flex
            className={`header-left-logo ${openSubBar ? "open-sidebar" : ""}`}
            me={openSidebar ? "" : "5"}
            mx={openSidebar ? "14" : "1"}
            display={{ sm: "none", xl: "flex" }}
          >
            {(largeLogo && largeLogo[0]?.logoLgImg) ||
            (largeLogo && largeLogo[0]?.logoSmImg) ? (
              <Image
                style={{
                  width: openSidebar ? "50px" : "30px",
                  height: "30px",
                  objectFit: "contain",
                }}
                src={
                  openSidebar === true
                    ? largeLogo[0]?.logoLgImg
                    : largeLogo[0]?.logoSmImg
                }
                alt="Logo"
                cursor="default" // Prevents hand pointer
                pointerEvents="none" // Makes it completely unclickable
                userSelect="none"
                my={2}
              />
            ) : (
              <Heading
                my={4}
                style={{
                  fontSize: 22,
                  lineHeight: "50px",
                  width: openSidebar ? "60px" : "60px",
                  height: "52px",
                }}
                userSelect={"none"}
                className="logoSidebar"
              >
                <Image
                  style={{
                    width: openSidebar ? "50px" : "30px",
                    height: "30px",
                    objectFit: "contain",
                  }}
                  className="logoWhite"
                  src={logoWhite}
                />
                <Image
                  style={{
                    width: openSidebar ? "100px" : "100px",
                    objectFit: "contain",
                    marginTop:'6px',
                  }}
                  className="logoMain"
                  src={logoMain}
                />
              </Heading>
            )}
          </Flex>
          {/* <Box display={{ sm: "none", xl: "flex" }} ms={openSidebar ? "" : "3"} onClick={() => {
						
						setOpenSidebar(!openSidebar)}} style={{ fontSize: "25px" }}>{openSidebar ? <AiOutlineMenuFold /> : <AiOutlineMenuUnfold />}</Box> */}
          {subRoute && subRoute.length > 0 && (
     
					<Box display={{ sm: "none", xl: "flex" }} ms={openSubBar ? "" : "3"} onClick={() =>{
						setOpenSubBar(!openSubBar)}} style={{ fontSize: "25px" }}>{openSubBar ? <AiOutlineMenuFold /> : <AiOutlineMenuUnfold />}</Box>)}
					<Link
						color={mainText}
						display={{ sm: "flex", xl: "none" }}
						className='hide-logo'
					>
						{largeLogo && largeLogo[0]?.logoLgImg ?
             <Image
							style={{ width: "100%", height: '52px' }}
							src={largeLogo[0]?.logoLgImg}
							alt="Logo"
							cursor="pointer"
							userSelect="none"
							my={2}
						/> 
            : 
            // <Heading my={4}	cursor={"pointer"} userSelect={"none"}>{openSidebar === true ? "pulseCRM pro" : "P"}</Heading>
            <>
            </>
            }
					</Link>

					{/* <Link
						color={mainText}
						href='#'
						pt="2px"
						bg='inherit'
						ps="30px"
						display={{ sm: "none", xl: "flex" }}
						borderRadius='inherit'
						fontWeight='bold'
						fontSize='24px'
						textTransform={"capitalize"}
						_hover={{ color: { mainText } }}
						_active={{
							bg: 'inherit',
							transform: 'none',
							borderColor: 'transparent'
						}}
						_focus={{
							boxShadow: 'none'
						}}>
						{brandText}
					</Link> */}
          {subRoute && subRoute.length > 0 && (
            <Box
              bg={sidebarBg}
              display={{ base: "none", xl: "flex" }}
              transition={variantChange}
              // w='280px'
              w={openSubBar ? "280px" : "80px"}
              h="100vh"
              m={sidebarMargins}
              minH="100%"
              overflowX="hidden"
              boxShadow={shadow}
              className="sidebar-right"
            >
              <div className="customScrollBar">
                <div className="scroll-container">
                  <div className="scroll-content">
                    <Content
                      isUserLayout={isUserLayout}
                      isNavbarMenu={false}
                      routes={subRoute}
                      largeLogo={largeLogo}
                      openSidebar={openSubBar}
                      setOpenSidebar={setOpenSubBar}
                      dynamic={true}
                    />
                  </div>
                </div>
              </div>
            </Box>
          )}
        </Box>
        <Box
          className="topNav-rightContent"
          ms="auto"
          height={"100%"}
          w={{ sm: "100%", md: "20%" }}
        >
          <AdminNavbarLinks
            openSubBar={openSubBar}
            setOpenSubBar={setOpenSubBar}
            isUserLayout={isUserLayout}
            setOpenSidebar={setOpenSidebar}
            openSidebar={openSidebar}
            onOpen={props.onOpen}
            logoText={props.logoText}
            secondary={props.secondary}
            fixed={props.fixed}
            scrolled={scrolled}
            routes={routes}
          />
        </Box>
      </Flex>
      {secondary ? <Text color="white">{message}</Text> : null}
    </Box>
  );
}

AdminNavbar.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
};
